module.exports = __webpack_public_path__ + "f87c0968397f68956df1061e6c9ca42e.svg";